//描述：错别字校对框
//作者：fanglijuan
//时间：2017-03-01
"use strict";
angular.module("heimacheckInputModule", []).
directive("heimacheckInput", ["heimaCheckService", "$timeout", function(heimaCheckService, $timeout) {
    return {
        scope: false,
        template: "",
        restrict: 'A',
        replace: false,
        //transclude: false,
        link: function($scope, $element, iAttrs, controller) {
            /*initStatus();
            var status;

            function initStatus() {
                status = {
                    modelName: iAttrs.ngModel,
                    name: iAttrs.ngModel.split(".")[iAttrs.ngModel.split(".").length - 1]
                };
            }*/
            /*$scope.$watch(status.modelName, function(newV, oldV) {
                if (!$scope.status.isCheckHeima) return;
                checkHeimaWord(newV);
            });*/
            $scope.$watch("status.isCheckHeima", function(newV, oldV) {
                if (Number(newV)!==0) {
                    checkHeimaWord($element.val());
                }else{
                    clearInput();
                }
            });
            var promise;

            function checkHeimaWord(heimaWordInput) {
                //获取当前页面所有的需要校验的input框信息
                var checkFieldArr = heimaCheckService.getCheckField();
                var currInputPosInfo = {};
                var currStartPos = 0;
                var currEndPos = 0;
                for (var i in checkFieldArr) {
                    if (heimaWordInput === checkFieldArr[i].checkValue) {
                        currInputPosInfo = checkFieldArr[i];
                        currStartPos = currInputPosInfo.srtatPos;
                        currEndPos = currStartPos + currInputPosInfo.valueLength - 1;
                    }
                }
                //getCurrInputPosInfo();

                heimaCheckService.getHeimaWordOfContent().then(function(data) {
                    //data是返回的文章的所有黑马信息
                    if (data.length > 0) {
                        var subHeimaWordsArr = [];
                        for (var i = 0; i < data.length; i++) {
                            var heimaErrorWord = data[i].errWord;
                            var pos = data[i].pos;
                            if (heimaWordInput.indexOf(heimaErrorWord) > -1 && (pos >= currStartPos && pos <= currEndPos)) {
                                subHeimaWordsArr.push(data[i]);
                            }
                        }
                        heimaCheckService.dealWithHeimaWordsArr(subHeimaWordsArr, 1).then(function(data) {
                            if (data.length > 0) {
                                markInput(data);
                            } else {
                                clearInput();
                            }
                        });
                    } else {
                        clearInput();
                    }
                });
            }

            function markInput(array) {
                var tipInfo = array.join(""); //getHeimaWordsTip(array);
                $element.prev("span").html('<p class="validation-invalid">错误信息（建议替换）：' + tipInfo + '</p><i></i>'); //添加提示信息；
                $element.addClass("hasHeimaWord");
                $element.parent().addClass("hasHeimaWordInputBox");
            }

            function clearInput() {
                $element.removeClass("hasHeimaWord");
                $element.parent().removeClass("hasHeimaWordInputBox");
            }

            /*function getHeimaWordsTip(array) {
                var tipInfo = "";
                for (var i = 0; i < array.length; i++) {
                    tipInfo += array[i].errWord + "，";
                }
                tipInfo = tipInfo.substring(0, tipInfo.length - 1);
                return tipInfo;
            }*/
        }
    };
}]);
